const MY_LGPD = {
  SHOW_TAGS: [
    'view_dashboard',
    'view_dashboard_process',
    'view_dashboard_gap',
    'view_dashboard_rnc',
    'stats_kanban_task',
  ],
}

const HOME = {
  SHOW_COMMUNICATION_TRAIL: 'show_communication_trail',
}

const COMPANIES = {
  LIST: 'list_companies',
  SHOW: 'show_company',
  CREATE: 'create_company',
  UPDATE: 'update_company',
  DELETE: 'destroy_company',
  UPDATE_SELF: 'update_self_company',
}

const INCIDENTS = {
  LIST: 'list_incidents',
  CREATE: 'detection_step_incident', // Permissão que deixa editar apenas até a etapa de avaliação
  MANAGE: 'create_incident',
}

const DATA_PROCESSES = {
  RESUME: 'resume_departments',
  CREATE: 'create_data_process',
  LIST: 'list_data_processes',
  LIST_AND_MANAGE_SUGGESTED: 'list_and_manage_suggested_data_processes',
  LIST_AND_MANAGE_SUGGESTED_CHANGE: 'list_and_manage_suggested_changes',
  INACTIVE_AND_REACTIVE: 'inactive_and_reactive_data_process',
  DESTROY: 'destroy_data_process',
  REVIEW: 'review_data_process',
  REOPEN: 'reopen_data_process',
  TAG: 'create_tag',
}

const COMPANY_FRAGILITIES = {
  LIST_COMPANY_FRAGILITIES: 'list_company_fragilities',
  MANAGE_COMPANY_FRAGILITIES: 'create_company_fragility',
  LIST_COMPANY_FRAGILITIES_BY_DEPARTMENT:
    'list_company_fragilities_by_department',
  MANAGE_COMPANY_FRAGILITIES_BY_DEPARTMENT:
    'create_company_fragility_by_department',
}

const PROFILES = {
  LIST: 'list_client_profiles',
  CREATE: 'create_client_profile',
  EDIT: 'edit_client_profile',
  CHANGE_STATUS: 'change_status_client_profile',
}

const DEPARTMENTS = {
  LIST: 'list_departments',
  CREATE: 'create_department',
  ACTIVATE_OR_INACTIVATE: 'activate_or_inactivate_department',
  LINK_USERS: 'link_users_to_department',
  DESTROY: 'destroy_department',
}

const COMMITTEES = {
  LIST: 'list_committees',
  MANAGE: 'create_committee',
}

const EXTERNAL_PLATFORM_INTEGRATIONS = {
  LIST: 'index_external_platform_integrations',
  MANAGE: 'create_external_platform_integration',
  UPDATE: 'update_external_platform_integration',
  DESTROY: 'destroy_external_platform_integration',
  CHANGE_STATUS: 'change_status_external_platform_integration',
}

const PRIVACY_POLICIES = {
  LIST: 'list_privacy_policy',
  CREATE: 'create_privacy_policy',
  STAMP: 'stamp_privacy_policy',
}

const PRIVACY_PORTAL_THEMES = {
  SHOW: 'show_privacy_portal_theme',
  MANAGE: 'manage_privacy_portal_theme',
}

const PHISHING = {
  DASHBOARD: 'dashboard_phishing_campaigns',
  LIST: 'index_phishing_campaigns',
  MANAGE: 'manage_phishing_campaigns',
  REPORT: 'export_phishing_campaigns',
}

const PAYMENT_ORDERS = {
  LIST: 'index_by_company_payment_order',
}

const COMPANY_SUPPLIERS = {
  LIST_IAM_CLIENT: 'list_client_company_suppliers',
  LIST_IAM_SUPPLIER: 'list_supplier_company_suppliers',
  SHOW: 'show_company_supplier',
  UPDATE: 'update_company_supplier',
}

const COMPANY_SUPPLIER_QUESTIONNAIRES_RECEIVED = {
  MANAGE: 'access_to_supplier_portal_company_supplier',
}

const SUPPLIER_SUGGESTIONS = {
  MANAGE: 'accepted_or_declined_supplier_suggestions',
}

const NON_COMPLIANCE_REPORT = {
  LIST: 'list_non_compliance_reports',
  RESUME: 'resume_non_compliance_report',
  EDIT: 'edit_non_compliance_report',
  HANDLE_ACTIONS: 'handle_non_compliance_reports_actions',
  HANDLE_SPECIFIC_RISKS: 'handle_specific_risks',
  LIST_DATA_PROCESSES: 'list_all_non_compliance_report_data_process',
  LIST_LINKED_DATA_PROCESS: 'list_linked_non_compliance_report_data_process',
  LIST_QUESTIONNAIRE: 'list_all_non_compliance_report_by_questionnaire',
  LIST_LINKED_QUESTIONNAIRE:
    'list_linked_non_compliance_report_by_questionnaire',
  LIST_INCIDENT: 'list_incident_non_compliance_reports',
  LIST_RESPONSIBLE: 'list_responsable_non_compliance_reports',
  LIST_RECOMMENDATION: 'list_recomendations_non_compliance_reports',
}

const USERS = {
  SHOW: 'show_user',
  LIST: 'list_users',
  CREATE: 'create_user',
  EDIT: 'edit_user',
  CHANGE_STATUS: 'change_user_status',
  SOFT_DELETE: 'soft_delete_user_company',
}

const QUESTIONNAIRES = {
  LINK_USERS: 'link_users',
  REPLY: 'reply_questionnaire',
}

const RIPD = {
  EXPORT: 'export_ripd',
}

const DASHBOARD = {
  VIEW: 'view_dashboard',
  VIEW_PROCESS: 'view_dashboard_process',
  VIEW_RMC: 'view_dashboard_rnc',
  VIEW_QUESTIONNAIRE: 'view_dashboard_gap',
}

const DOCUMENTS_TEMPLATE = {
  LIST: 'list_document_templates',
}

const PERMISSIONS_PRIVATE_DOCUMENT_LABEL = {
  LIST_PRIVATE_DOCUMENT: 'Visualizar documentos privados',
}

const EXPORT_INFO = {
  EXPORT_RIPD: 'export_ripd',
}

const SMTP_CREDENTIAL = {
  MANAGE: 'create_smtp_credential',
}

const PERMISSIONS_DEFAULT_LABEL = {
  LIST: 'Listar',
  CREATE: 'Criar',
  EDIT: 'Editar',
  DESTROY: 'Deletar',
  ACTIVATE_OR_INACTIVATE: 'Ativar/Inativar',
  SOFT_DELETE: 'Excluir',
  MANAGE: 'Gerenciar',
  VISUALIZE: 'Visualizar',
  INTERACT: 'Interagir',
}

const TRANSLATED_PERMISSIONS_LIST = {
  aiInventoryList: 'Inventário de IA',
  assetInventoryList: 'Inventário de ativos',
  auditList: 'Auditoria',
  changesManagementList: 'Gestão de mudanças',
  committeeList: 'Comitês',
  companyFragilities: 'Ameaças',
  companyList: 'Dados cadastrais da empresa',
  companySupplierQuestionnairesReceivedList:
    'Fornecedores - Questionários Recebidos',
  companySuppliers: 'Fornecedores - Meus Fornecedores/Meus Pré Avaliados',
  complaintList: 'Canal de denúncias',
  consentList: 'Consentimentos',
  consentReceiptList: 'Recibos de consentimentos',
  cookiesList: 'Cookies',
  dashboardList: 'Indicadores',
  dataProcessList: 'Processos',
  departmentList: 'Departamentos',
  diagnosticsList: 'Diagnósticos',
  documentList: 'Documentos desatualizados',
  documentTemplateList: 'Documentos modelo',
  governanceProjectList: 'Projetos de governança',
  incidentList: 'Incidentes',
  lastUpdate: 'Ultimas atualizações',
  marketplaceList: 'Marketplace',
  monitoringManagementKpiList: 'KPIs',
  monitoringManagementPdcaList: 'PDCAs',
  monitoringManagementPmcList: 'PMCs',
  monitoringManagementNcList: 'NCs',
  paymentList: 'Painel financeiro',
  monitoringManagementNCList: 'NCs',
  privacyByDesignList: 'Privacy By Design',
  privacyPolicyList: 'Documentos',
  privacyPortalThemeList: 'Tema',
  phishingList: 'Phishing',
  profileList: 'Perfis',
  questionnaireList: 'Questionários',
  ripdList: 'Relatório de impacto à proteção de dados',
  smtpCredentialList: 'Credenciais SMTP',
  supplierSuggestionsList: 'Fornecedores - Sugestões',
  taskList: 'Atividades',
  titularTicketList: 'Solicitação de titulares',
  trainingList: 'Treinamentos',
  userList: 'Usuários',
  trainningJourneyList: 'Jornada de treinamento',
}

const LAST_UPDATE = {
  LIST: 'list_last_updates',
}

const FAQS_DOCUMENTATIONS = {
  LIST: 'list_faqs_documentations',
}

const DIAGNOSTICS = {
  UPDATE: 'update_question_control',
  TAKE_RISK: 'take_risk_question_control',
  OPEN_WRITE: 'open_write_question_control',
  LIST: 'list_question_controls',
}

const CONSENTS = {
  LIST: 'list_consent_form',
  CREATE: 'create_consent_form',
  SHOW: 'show_consent_form',
  CHANGE_FORM_STATUS: 'change_status_consent_form',
  CHANGE_RESPONSIBLE: 'change_responsible_consent_form',
  DESTROY: 'destroy_consent_form',
}

const CONSENT_RECEIPTS = {
  LIST: 'list_consent_form_answer',
  CREATE: 'create_consent_form_answer',
  SHOW: 'show_consent_form_answer',
  CHANGE_STATUS: 'change_status_consent_form_answer',
  DESTROY: 'destroy_consent_form_answer',
}

const GOVERNANCE_PROJECTS = {
  CREATE: 'create_governance_project',
  CHANGE_STATUS: 'change_status_governance_project',
}

const MARKETPLACE = {
  VIEW: 'view_marketplace',
}

const COMPLAINTS = {
  LIST: 'list_complaints',
  SHOW: 'show_complaint',
  REGISTER_RESPONSIBLE: 'register_responsible_complaint',
  ACTIVATE_COMPLAINTS: 'activate_complaints',
  MANAGE_CONFIGURATIONS: 'manage_complaint_configurations',
  LIST_CONFIGURATIONS: 'list_complaint_configurations',
}

const COMPLAINT_MESSAGES = {
  CREATE: 'create_complaint_message',
}

const AUDITS = {
  VIEW: 'show_audit_config',
  MANAGE: 'update_audit_config',
  FINALIZE: 'finalize_company_audit',
}

const MOODLE_TRAININGS = {
  VIEW: 'view_moodle_training',
}

const COOKIES = {
  MANAGE: 'authenticate_cookie',
}

const ASSET_INVENTORY = {
  SHOW: 'show_asset_inventory',
  MANAGE: 'create_asset_inventory',
}

const AI_INVENTORY = {
  LIST: 'list_ai_inventory',
  SHOW: 'show_ai_inventory',
  MANAGE: 'create_ai_inventory',
  MANAGE_GUEST_PORTAL: 'manage_ai_inventory_guest_portal',
}

const PRIVACY_BY_DESIGN = {
  LIST: 'list_privacy_by_design',
  MANAGE: 'create_privacy_by_design',
  MANAGE_GUEST_PORTAL: 'manage_privacy_by_design_guest_portal',
}

const DATA_PROCESS_TREATMENT = {
  MANAGE: 'create_data_process_treatment',
  LIST: 'list_data_process_treatments',
}

const MONITORING_MANAGEMENT_KPI = {
  LIST: 'list_monitoring_management_kpi',
  MANAGE: 'create_monitoring_management_kpi',
}
const MONITORING_MANAGEMENT_PDCA = {
  LIST: 'index_pdcas',
  MANAGE: 'create_pdca',
}

const MONITORING_MANAGEMENT_NC = {
  LIST: 'list_monitoring_management_nc',
  MANAGE: 'create_monitoring_management_nc',
}

const MONITORING_MANAGEMENT_PMC = {
  LIST: 'list_monitoring_management_pmc',
  MANAGE: 'create_monitoring_management_pmc',
}

const CHANGES_MANAGEMENT = {
  LIST: 'list_changes_management',
  MANAGE: 'create_changes_management',
}

const TITULAR_TICKETS = {
  LIST: 'list_titular_tickets',
  INTERACT: 'create_titular_ticket_message',
  MANAGE_CONFIGURATIONS: 'change_titular_ticket_responsibles',
}

const TRAINNING_JOURNEYS = {
  MANAGE: 'notify_pending_trainning',
}

const NEW_PLATFORM_COURSE = {
  CONFIG: 'training_course_company_config_upsert',
  SHOW: 'training_course_index',
  TREINING_PORTAL: 'training_course_portal_link',
}

const KANBAN_TASKS = {
  LIST: 'list_kanban_task',
  LIST_BY_DEPARTMENT: 'list_by_department_kanban_task',
  MANAGE: 'create_kanban_task',
  FINALIZE: 'finalize_kanban_task',
  DESTROY: 'destroy_kanban_task',
  MANAGE_COLUMNS: 'create_kanban_column',
  DESTROY_COLUMN: 'destroy_kanban_column',
  DESTROY_COMMENT: 'destroy_task_comment',
  STATS: 'stats_kanban_task',
}

const permissions = {
  AI_INVENTORY,
  ASSET_INVENTORY,
  AUDITS,
  CHANGES_MANAGEMENT,
  COMMITTEES,
  COMPANIES,
  COMPANY_FRAGILITIES,
  COMPANY_SUPPLIER_QUESTIONNAIRES_RECEIVED,
  COMPANY_SUPPLIERS,
  COMPLAINT_MESSAGES,
  COMPLAINTS,
  CONSENT_RECEIPTS,
  CONSENTS,
  COOKIES,
  DASHBOARD,
  DATA_PROCESS_TREATMENT,
  DATA_PROCESSES,
  DEPARTMENTS,
  DIAGNOSTICS,
  DOCUMENTS_TEMPLATE,
  EXPORT_INFO,
  EXTERNAL_PLATFORM_INTEGRATIONS,
  FAQS_DOCUMENTATIONS,
  GOVERNANCE_PROJECTS,
  HOME,
  INCIDENTS,
  KANBAN_TASKS,
  LAST_UPDATE,
  MARKETPLACE,
  MONITORING_MANAGEMENT_KPI,
  MONITORING_MANAGEMENT_NC,
  MONITORING_MANAGEMENT_PDCA,
  MONITORING_MANAGEMENT_PMC,
  MOODLE_TRAININGS,
  MY_LGPD,
  NON_COMPLIANCE_REPORT,
  PAYMENT_ORDERS,
  PERMISSIONS_DEFAULT_LABEL,
  PERMISSIONS_PRIVATE_DOCUMENT_LABEL,
  PRIVACY_BY_DESIGN,
  PRIVACY_POLICIES,
  PRIVACY_PORTAL_THEMES,
  PHISHING,
  PROFILES,
  QUESTIONNAIRES,
  RIPD,
  SMTP_CREDENTIAL,
  SUPPLIER_SUGGESTIONS,
  TITULAR_TICKETS,
  TRAINNING_JOURNEYS,
  TRANSLATED_PERMISSIONS_LIST,
  USERS,
  NEW_PLATFORM_COURSE,
}

export default permissions
